const DANCE_TYPE_ALIASES = {
  tango: 'Tango',
  fusion: 'Fusion',
  salsa: 'Salsa',
  bachata: 'Bachata',
  zouk: 'Brazilian Zouk',
  brazilianzouk: 'Brazilian Zouk',
  contact: 'Improvisation',
  'contact-improvisation': 'Improvisation',
  improvisation: 'Improvisation',
  meditation: 'Meditation',
  yoga: 'Yoga',
  dance: 'Dance Show',
  'dance-show': 'Dance Show',
  ballet: 'Contemporary Ballet',
  'contemporary-ballet': 'Contemporary Ballet',
  ecstaticdance: 'Ecstatic Dance',
  'ecstatic-dance': 'Ecstatic Dance',
  swing: 'West Coast Swing',
  wcs: 'West Coast Swing',
  'west-coast-swing': 'West Coast Swing',
  all: 'All',
};

function aliasToDanceType(value) {
  return DANCE_TYPE_ALIASES[String(value || '').trim().toLowerCase()] || null;
}

export function getDanceTypeFilterFromUrl(search = '', pathname = '') {
  const params = new URLSearchParams(search);
  const canonical = String(params.get('danceType') || '').trim();
  if (canonical) return aliasToDanceType(canonical) || canonical;

  const style = aliasToDanceType(params.get('style'));
  if (style) return style;

  const lastSegment = String(pathname).split('/').filter(Boolean).pop();
  return aliasToDanceType(lastSegment) || 'All';
}

export function updateDanceTypeFilterSearch(search, danceType) {
  const params = new URLSearchParams(search);
  const selected = String(danceType || '').trim();
  const legacyStyle = params.get('style');

  params.delete('danceType');

  if (!selected || selected === 'All') {
    params.delete('style');
  } else if (legacyStyle && aliasToDanceType(legacyStyle) === selected) {
    // Do not rewrite working landing-page links until the visitor changes type.
  } else {
    params.delete('style');
    params.set('danceType', selected);
  }

  const query = params.toString();
  return query ? `?${query}` : '';
}
